import { useState } from 'react'
import { MessageCircle, X } from 'lucide-react'

const WHATSAPP_NUMBER = '919750252635'
const DEFAULT_MESSAGE = 'Hi Maitreyi Foods! I would like to know more about your organic products.'

function WhatsAppButton() {
    const [showTooltip, setShowTooltip] = useState(false)

    const handleClick = () => {
        const encodedMessage = encodeURIComponent(DEFAULT_MESSAGE)
        window.open(
            `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`,
            '_blank',
            'noopener,noreferrer'
        )
    }

    return (
        <div className="fixed bottom-28 md:bottom-8 right-5 z-50 flex flex-col items-end gap-3">
            {/* Tooltip */}
            {showTooltip && (
                <div className="animate-fade-in bg-white rounded-2xl shadow-2xl border border-gray-100 p-4 max-w-[260px] relative">
                    <button
                        onClick={() => setShowTooltip(false)}
                        className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors"
                        aria-label="Close tooltip"
                    >
                        <X className="w-4 h-4" />
                    </button>
                    <div className="flex items-center gap-2 mb-2">
                        <div className="w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center">
                            <svg className="w-4 h-4 text-white" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                            </svg>
                        </div>
                        <div>
                            <p className="text-sm font-bold text-gray-900">Maitreyi Foods</p>
                            <p className="text-[10px] text-emerald-600 font-medium">Typically replies instantly</p>
                        </div>
                    </div>
                    <p className="text-xs text-gray-600 mb-3 leading-relaxed">
                        👋 Need help? Chat with us on WhatsApp for quick support!
                    </p>
                    <button
                        onClick={handleClick}
                        className="w-full bg-emerald-500 hover:bg-emerald-600 text-white text-sm font-semibold py-2.5 px-4 rounded-xl transition-all duration-200 flex items-center justify-center gap-2 shadow-md shadow-emerald-200 hover:shadow-lg hover:shadow-emerald-300"
                    >
                        <MessageCircle className="w-4 h-4" />
                        Start Chat
                    </button>
                </div>
            )}

            {/* Floating WhatsApp Button */}
            <button
                onClick={() => setShowTooltip(!showTooltip)}
                className="group relative w-14 h-14 bg-[#25D366] hover:bg-[#20BD5A] text-white rounded-full shadow-lg shadow-emerald-300/40 hover:shadow-xl hover:shadow-emerald-400/50 transition-all duration-300 flex items-center justify-center hover:scale-110 active:scale-95"
                aria-label="Chat on WhatsApp"
            >
                {/* Pulse ring animation */}
                <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />

                {/* WhatsApp Icon */}
                <svg className="w-7 h-7 relative z-10" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
            </button>
        </div>
    )
}

export default WhatsAppButton
